import { api } from './client'

// Lịch sử phiên bản + link xem trước của bài / trang website (cms-plan E6).

export type ShopContentDoc = 'posts' | 'pages'

export interface ShopContentRevision {
    id: string
    doc_type: 'post' | 'page'
    doc_id: string
    version: number
    title: string
    snapshot?: Record<string, unknown>
    by_name: string | null
    created_at: string
}

export interface ShopPreviewLink {
    url: string
    expires_at: string
}

export const shopContentToolsApi = {
    revisions: (doc: ShopContentDoc, id: string) =>
        api.get<ShopContentRevision[]>(`/shop-admin/${doc}/${id}/revisions`),
    revision: (doc: ShopContentDoc, id: string, rid: string) =>
        api.get<ShopContentRevision>(
            `/shop-admin/${doc}/${id}/revisions/${rid}`,
        ),
    restore: (doc: ShopContentDoc, id: string, rid: string, version: number) =>
        api.post<{ id: string; version: number }>(
            `/shop-admin/${doc}/${id}/revisions/${rid}/restore`,
            { version },
        ),
    previewLink: (doc: ShopContentDoc, id: string) =>
        api.post<ShopPreviewLink>(`/shop-admin/${doc}/${id}/preview-link`, {}),
}
